import RequestViewDetailsVendorContainer from "../containers/VendorDetails/RequestViewDetailsVendor/index";
import React from "react";

const RequestViewDetailsVendor = (props) => {
  return (
    <>
      <RequestViewDetailsVendorContainer
      {...props}
      
      
       />
    </>
  );
};

export default RequestViewDetailsVendor;